"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderDriverCompulsoryExcess = void 0;
exports.getAddressToRender = getAddressToRender;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var commonFunctions_1 = require("../commonFunctions");
var renderDriverCompulsoryExcess = function (interaction, vehicle) {
    var allDrivers = [interaction.policyHolder].concat(interaction.additionalDrivers || []);
    var vehicleDrivers = [];
    if (vehicle.driverIds) {
        vehicleDrivers = vehicle.driverIds.map(function (driverId) { return allDrivers.find(function (driver) { return driverId === driver.personId; }); }).filter(function (driver) { return driver !== undefined; });
    }
    return vehicleDrivers.map(function (driver, index) {
        var driverCompExcess = driver.excesses.adExcess + vehicle.excesses.adExcess;
        var driverDescription = driver.personId === vehicle.mainDriverId ? "main driver" : "additional driver";
        return ((0, jsx_runtime_1.jsxs)("div", { className: "text-center m-0 font-weight-extra-light", children: ["".concat(driver.firstName, " ").concat(driver.lastName, ", "), (0, jsx_runtime_1.jsxs)("span", { className: "font-weight-semi-bold", children: [driverDescription, ":"] }), " \u00A3".concat(driverCompExcess)] }, index));
    });
};
exports.renderDriverCompulsoryExcess = renderDriverCompulsoryExcess;
function getAddressToRender(address) {
    var addressComponents = (0, commonFunctions_1.getAddressLines)(address);
    return addressComponents.map(function (component, index) { return (index % 2 === 0) && (index < addressComponents.length - 1) ?
        (0, jsx_runtime_1.jsx)("span", { className: "detail-value", children: component }, index) :
        (0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)("span", { className: "detail-value", children: [", ", component] }, index), (0, jsx_runtime_1.jsx)("br", {})] }); });
}
//# sourceMappingURL=CommonRenderers.js.map